import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  getReferralReportsPageIsLoaded,
  getReferralsByDepartment,
  getReferralsByJobFunction,
} from '@modules/reports/store/referral-reports.selectors';
import { Store } from '@ngrx/store';
import { IsMobileViewService } from '@shared/services/is-mobile-view.service';
import { PieChartCommons } from '@shared/util-pie-chart/pieChartCommons';
import { PieChartElement } from 'mojo-pie-chart/lib/pie-chart-element.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'mojo-referral-reports-charts',
  templateUrl: './referral-reports-charts.component.html',
  styleUrls: ['./referral-reports-charts.component.scss'],
})
export class ReferralReportsChartsComponent implements OnInit {
  @Output()
  functionSelection = new EventEmitter<string>();

  @Output()
  departmentSelection = new EventEmitter<string>();
  elementsDep: PieChartElement[] = [];
  isLoaded = false;

  elementsDep$: Observable<PieChartElement[]>;
  elementsJobFun$: Observable<PieChartElement[]>;
  isLoaded$ = this.store.select(getReferralReportsPageIsLoaded);
  expanded = false;
  expandedFun = false;
  expandedDep = false;
  static noDepartment = 'No department';
  static noJobFunction = 'No job function';
  constructor(private store: Store, public isMobileViewService: IsMobileViewService) {}

  ngOnInit(): void {
    this.elementsDep$ = this.store
      .select(getReferralsByDepartment)
      .pipe(
        map((data) =>
          this.createPieChartElement(data, ReferralReportsChartsComponent.noDepartment),
        ),
      );

    this.elementsJobFun$ = this.store
      .select(getReferralsByJobFunction)
      .pipe(
        map((data) =>
          this.createPieChartElement(data, ReferralReportsChartsComponent.noJobFunction),
        ),
      );
  }

  functionSelected(elem: PieChartElement) {
    if (elem.label === ReferralReportsChartsComponent.noJobFunction) {
      return;
    }
    this.functionSelection.emit(elem.label);
  }

  departmentSelected(elem: PieChartElement) {
    if (elem.label === ReferralReportsChartsComponent.noDepartment) {
      return;
    }
    this.departmentSelection.emit(elem.label);
  }

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  toggleExpandFun() {
    this.expandedFun = !this.expandedFun;
  }

  toggleExpandDep() {
    this.expandedDep = !this.expandedDep;
  }

  private createPieChartElement(data, emptyValue) {
    let i = 0;
    return data.map((elem) => ({
      label: elem.name == null ? emptyValue : elem.name,
      color:
        i < PieChartCommons.colors.length
          ? PieChartCommons.colors[i++]
          : PieChartCommons.getRandomColor(),
      value: elem.count,
      filterKey: '-1',
    }));
  }
}
